import { render, staticRenderFns } from "./PopoverOrganizationSelect.vue?vue&type=template&id=18b345b9"
import script from "./PopoverOrganizationSelect.vue?vue&type=script&lang=js"
export * from "./PopoverOrganizationSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports